import React, { PureComponent } from 'react';
import ObtenerAjusteCargoMotivo from './ObtenerAjusteCargoMotivo';

class TablaAjusteCargoMotivoRow extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { movimientosFiltradosParaMostrarPanel, destildarTildarCheckFiltroAjusteCargo } = this.props;
        let movFiltradosParaMostrarPanel;

        if (movimientosFiltradosParaMostrarPanel.length > 0) {
            movFiltradosParaMostrarPanel = movimientosFiltradosParaMostrarPanel.map(function (movFiltrado) {
                return (
                    <ObtenerAjusteCargoMotivo movFiltrado={movFiltrado} destildarTildarCheckFiltroAjusteCargo={destildarTildarCheckFiltroAjusteCargo} />
                );
            });
        }

        return (
            <tr>
                <td colSpan="4">
                    {movFiltradosParaMostrarPanel}
                </td>
            </tr>
        );
    }
}

export default TablaAjusteCargoMotivoRow;